module.exports = __webpack_public_path__ + "img/reserve_min_order.5a6faefc.svg";